export type EventBookNowCacheEntry = {
	bookNowHref: string | null;
};

const cache = new Map<string, EventBookNowCacheEntry>();
const listeners = new Set<() => void>();

export function getEventBookNowCacheKey(restaurantId: string, eventId: string): string {
	return `${restaurantId}:${eventId}`;
}

export function getCachedEventBookNow(key: string): EventBookNowCacheEntry | undefined {
	return cache.get(key);
}

export function isEventBookNowCached(key: string): boolean {
	return cache.has(key);
}

/**
 * Writes once per key — event book-now URLs are treated as stable for the session.
 * Allows upgrading a cached "no availability" (null) entry when a later fetch finds a URL.
 */
export function setCachedEventBookNow(key: string, entry: EventBookNowCacheEntry): void {
	const existing = cache.get(key);
	if (existing && !(existing.bookNowHref === null && entry.bookNowHref !== null)) {
		return;
	}
	cache.set(key, entry);
	for (const listener of listeners) {
		listener();
	}
}

export function subscribeEventBookNowCache(listener: () => void): () => void {
	listeners.add(listener);
	return () => {
		listeners.delete(listener);
	};
}
